<div class="error-notification-container"
     *ngIf="error">
	<div class="error-notification">
		<div class="error-description">
			{{errorDescription}}
		</div>
		<form [formGroup]="form">
			<div class="row">
				<div class="col-md-12">
					<mat-form-field class="full-width">
						<mat-label>Name</mat-label>
						<input matInput
						       formControlName="name"
						       [style.background-image]="'none'">
						<mat-error>Name is required</mat-error>
					</mat-form-field>
				</div>
				<div class="col-md-12">
					<mat-form-field class="full-width">
						<mat-label>Mobile</mat-label>
						<input matInput
						       formControlName="mobile"
						       [style.background-image]="'none'">
						<mat-error>Mobile is required</mat-error>
					</mat-form-field>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<dodo-raised-button>Submit</dodo-raised-button>
				</div>
			</div>
		</form>
	</div>

</div>
